import type { ReactNode } from "react";
import { DsLogo } from "../DsLogo";

type DsHeaderProps = {
  endContent?: ReactNode;
};

/** Altura do header no Figma: py-12 (24) + avatar 40 = 64px. */
const HEADER_HEIGHT_CLASS = "h-16";

function DsHeader({ endContent }: DsHeaderProps) {
  return (
    <>
      <header
        className={`fixed top-0 right-0 left-0 z-20 flex ${HEADER_HEIGHT_CLASS} w-full items-center justify-between bg-body-light-mode-1 px-6`}
        data-id="checkout-header"
      >
        <DsLogo
          className="h-[23px] w-[29px]"
          data-id="header-logo"
          data-name="Logo"
          data-testid="logo"
        />
        {endContent ? (
          <div className="flex shrink-0 items-center justify-end gap-4" data-slot="header-end-content">
            {endContent}
          </div>
        ) : (
          <span aria-hidden className="size-0 shrink-0" />
        )}
      </header>
      <div aria-hidden className={`${HEADER_HEIGHT_CLASS} shrink-0`} />
    </>
  );
}

export { DsHeader };
export type { DsHeaderProps };
